export enum RegistrationDisplayFlags {
    NOT_USED = 1,
    USED_FOR_PUBLIC_REGISTRATION = 2,
    USED_FOR_ADMINISTRATIVE_REGISTRATION = 3,
    ALWAYS_USED = 4,
}